module.exports = function() {

// エスケープメソッド
App.e = function(text) {
    if (!text) {
        return '';
    }
    text = "" + text;//文字列に変換
    text = _.escape(text);
    text = text.replace(/((http:|https:)\/\/[\x21-\x26\x28-\x7e]+)/gi, '<a href="$1">$1</a>');
    text =  text.replace(/\r\n/g, "<br>");
    text = text.replace(/(\n|\r)/g, "<br>");
    return text;
};

// 通信エラーをアラートする
App.networkErrorAlert = function() {
    alert('通信エラーが発生しました。');
};

// UAからOSを判定する
App.getOS = function() {
    var ua = navigator.userAgent,
        os;

    // OSの判定
    if (ua.match(/Win(dows )?NT 6\.2/)) {
        os = "Windows 8";               // Windows 8 の処理
    } else if (ua.match(/Win(dows )?NT 6\.1/)) {
        os = "Windows 7";               // Windows 7 の処理
    } else if (ua.match(/Win(dows )?NT 6\.0/)) {
        os = "Windows Vista";               // Windows Vista の処理
    } else if (ua.match(/Win(dows )?NT 5\.2/)) {
        os = "Windows Server 2003";         // Windows Server 2003 の処理
    } else if (ua.match(/Win(dows )?(NT 5\.1|XP)/)) {
        os = "Windows XP";              // Windows XP の処理
    } else if (ua.match(/Win(dows)? (9x 4\.90|ME)/)) {
        os = "Windows ME";              // Windows ME の処理
    } else if (ua.match(/Win(dows )?(NT 5\.0|2000)/)) {
        os = "Windows 2000";                // Windows 2000 の処理
    } else if (ua.match(/Win(dows )?98/)) {
        os = "Windows 98";              // Windows 98 の処理
    } else if (ua.match(/Win(dows )?NT( 4\.0)?/)) {
        os = "Windows NT";              // Windows NT の処理
    } else if (ua.match(/Win(dows )?95/)) {
        os = "Windows 95";              // Windows 95 の処理
    } else if (ua.match(/Mac|PPC/)) {
        os = "Mac OS";                  // Macintosh の処理
    } else if (ua.match(/Linux/)) {
        os = "Linux";                   // Linux の処理
    } else if (ua.match(/^.*\s([A-Za-z]+BSD)/)) {
        os = RegExp.$1;                 // BSD 系の処理
    } else if (ua.match(/SunOS/)) {
        os = "Solaris";                 // Solaris の処理
    }

    return os;
};

// UAからブラウザ判定する
App.getBrowser = function() {
    var ua = navigator.userAgent,
        product;

    // ブラウザの判定
    ua = ua.toLowerCase();
    if (ua.indexOf('opera') != -1) {
        product = 'Opera';
    } else if (ua.indexOf('msie') != -1) {
        if (ua.indexOf("msie 6.") != -1) {
            product = 'IE6';
        } else if (ua.indexOf("msie 7.") != -1) {
            product = 'IE7';
        } else if (ua.indexOf("msie 8.") != -1) {
            product = 'IE8';
        } else if (ua.indexOf("msie 9.") != -1) {
            product = 'IE9';
        } else if (ua.indexOf("msie 10.") != -1) {
            product = 'IE10';
        } else {
            product = 'IE';
        }
    } else if (ua.indexOf('chrome') != -1) {
        product = 'Chrome';
    } else if (ua.indexOf('safari') != -1) {
        product = 'Safari';
    } else if (ua.indexOf('gecko') != -1) {
        product = 'Gecko';
    }

    return product;
};

// IEかどうかを判定する
App.isIE = function() {
    var ua = navigator.userAgent;

    // ブラウザの判定
    ua = ua.toLowerCase();
    if (ua.indexOf('msie') != -1) {
        return true;
    }
    return false;
};

// 二重クリック防止のために用いてる。
// enabledがfalseのときはdata-disabled属性にtrueをセットする
App.setEnabled = function($element, enabled) {
    if (enabled) {
        $element.removeAttr('data-disabled');
    } else {
        $element.attr('data-disabled', 'true');
    }
};

// 二重クリック防止のために用いてる。
// data-disabled属性にtrueをセットされているかどうか判定する
App.isEnabled = function($element) {
    return $element.attr('data-disabled') !== 'true';
};

// 主に、Ajax通信中にボタンの文言を変更するときに使う
// data-pre-textに変更前の文言を保持することで、あとで文言を戻すことができる
App.changeText = function($element, text) {
    text = text || '';

    if (text) {
        $element.attr('data-pre-text', $($element[0]).text());
        $element.text(text);
    }
};

// 変更前の文言に戻す
App.restoreText = function($element) {
    var pre_text = $element.attr('data-pre-text');

    if (pre_text) {
        $element.text(pre_text);
        $element.removeAttr('data-pre-text');
    }
};

// changeTextのinput版
App.changeValue = function($element, value) {
  value = value || '';
  if (value) {
    $element.attr('data-pre-value', $($element[0]).val());
    $element.val(value);
  }
};

// 変更前の文言に戻す
App.restoreValue = function($element) {
    var preValue = $element.attr('data-pre-value');
    if (preValue) {
      $element.val(preValue);
      $element.removeAttr('data-pre-value');
    }
};

// XHRオブジェクトのresponseTextプロパティをJSONデコードする
App.parseError = function(jqXHR) {
    try {
        return $.parseJSON(jqXHR.responseText);
    } catch(e) {
        return false;
    }
};

// ajaxでvalidatoinエラーの際にアラートを挙げる
App.validateErrorAlert = function(validation_obj) {
    var error_msg = "";
    _.each(validation_obj, function(fields, model){
      _.each(fields, function(msg, field){
        //error_msg += field;
        //error_msg += ": ";
        error_msg += msg;
        error_msg += "\n";
      });
    });
    alert(error_msg);
};

// mamariQのUser.idを取得する
App.getMamariqUserId = function() {
  var mamariq_user_id = App.vars.mamariq_user_id;
  if (! _.isEmpty(localStorage)) {
    if (_.isEmpty(mamariq_user_id)) {
      // PHPからUser.idが渡されていない場合はLocalStorageから取得
      mamariq_user_id = localStorage.getItem('mamariq_user_id');
    } else {
      // PHPから渡されたUser.idをLocalStorageへ保存
      localStorage.setItem('mamariq_user_id', mamariq_user_id)
    }
  }
  return mamariq_user_id;
}

// MixpanelにPR記事の既読履歴を保存する
App.storeReadSponsoredArticle = function(article_id) {
  if (_.isEmpty(localStorage)) {
    return false;
  }
  var read_sponsored_article_list = localStorage.getItem('read_sponsored_article_list') || '[]';
  read_sponsored_article_list     = JSON.parse(read_sponsored_article_list);

  // 先頭に追加して、全体で30記事分LocalStorageへ保持する
  read_sponsored_article_list.unshift(article_id);
  read_sponsored_article_list = _.uniq(read_sponsored_article_list);
  read_sponsored_article_list = read_sponsored_article_list.slice(0, 30);
  localStorage.setItem('read_sponsored_article_list', JSON.stringify(read_sponsored_article_list));

  // Mixpanelへ保存
  var mamariq_user_id = App.getMamariqUserId();
  if (_.isEmpty(mamariq_user_id)) {
    return false;
  }
  mixpanel.identify(mamariq_user_id);
  mixpanel.people.set('ReadSponsoredArticleList', read_sponsored_article_list);
  return true;
}

};



// WEBPACK FOOTER //
// ./util.js